
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Regular","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","stroke-width":"1.5","height":"48","width":"48"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('title',[_v('night-moon-new')]),_c('path',{attrs:{"d":"M11.437 11.959a11.254 11.254 0 0 1 7.876-10.733 11.25 11.25 0 1 0 0 21.466 11.254 11.254 0 0 1-7.876-10.733Z","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","fill-rule":"evenodd"}})])
          )
        }
      }
    